export const CIRCLE_LEARNING_POINT_OPTIONS = [
  { id: "kid_friendly", label: "Kid-friendly" },
  { id: "learn_play", label: "Learn & Play" },
  { id: "language_growth", label: "Language Growth" },
  { id: "creative_expression", label: "Creative Expression" },
  { id: "confidence_building", label: "Confidence Building" },
  { id: "academic_support", label: "Academic Support" },
  { id: "community_connect", label: "Community Connect" },
  { id: "faith_values", label: "Faith & Values" },
  { id: "homework_help", label: "Homework Help" },
  { id: "exam_readiness", label: "Exam Readiness" },
] as const;

export const CIRCLE_LEARNING_POINT_MAX = 3;

/** Shown under the learning-points field when valid */
export const LEARNING_POINTS_HELPER_TEXT = `Choose 1–${CIRCLE_LEARNING_POINT_MAX} tags for this circle.`;

/** Field-level validation when submit with none selected */
export const LEARNING_POINTS_REQUIRED_MESSAGE =
  "Select at least one learning point (maximum 3).";

/** Circle description (create / edit) */
export const CIRCLE_DESCRIPTION_MAX_LENGTH = 500;

export const DESCRIPTION_HELPER_TEXT = `Briefly describe this circle for members (max ${CIRCLE_DESCRIPTION_MAX_LENGTH} characters).`;

export const DESCRIPTION_REQUIRED_MESSAGE =
  "Description is required.";

export const DESCRIPTION_MAX_LENGTH_MESSAGE = `Description must be at most ${CIRCLE_DESCRIPTION_MAX_LENGTH} characters.`;
